import { gql } from 'apollo-angular';

export const REMOVE_INVOICE_BY_ID = gql`
  mutation deleteInvoice($invoiceId: Int!) {
    deleteInvoice(invoiceId: $invoiceId)
  }
`;


export const REMOVE_INVOICE_ITEM_BY_ID = gql`
  mutation removeInvoiceItem($id: Int!) {
    removeInvoiceItem(id: $id)
  }
`;

export const CREATE_INVOICE = gql`
  mutation CreateInvoice(
    $createInvoiceInput: CreateInvoiceInput!
    $createInvoiceItemInput: [CreateInvoiceItemInput!]
    $createInvoiceAttachmentInput: [CreateInvoiceAttachmentInput!]
    $dlpId: Int
  ) {
    createInvoice(
      createInvoiceInput: $createInvoiceInput
      createInvoiceItemInput: $createInvoiceItemInput
      createInvoiceAttachmentInput: $createInvoiceAttachmentInput
      dlpId: $dlpId
    ) {
      id
      invoiceNo
      totalPrice
      balance
      status
      invoiceDate
      branchId
      dueDate
    }
  }
`;

export const GENERATE_INVOICE_PDF = gql`
  mutation generateInvoicePdf($invoiceId: Int!) {
    generateInvoicePdf(invoiceId: $invoiceId)
  }
`;

export const CREATE_NEW_INVOICE = gql`
  mutation createInvoice($createInvoiceInput: CreateInvoiceInput!) {
    createInvoice(createInvoiceInput: $createInvoiceInput) {
      id
      invoiceNo
      subTotal
      discount
      tax
      totalAmount
      balance
      invoiceStatus
      orderId
      customerId
      invoiceDate
    }
  }
`;

export const UPDATE_INVOICE_BY_ID = gql`
  mutation updateInvoice($updateInvoiceInput: CreateInvoiceInput!, $id: Int!) {
    updateInvoice(updateInvoiceInput: $updateInvoiceInput, id: $id) {
      id
      invoiceNo
      subTotal
      discount
      tax
      totalAmount
      balance
      invoiceStatus
      orderId
      customerId
      invoiceDate
    }
  }
`;

export const INVOICE_APPROVE_OR_REJECT = gql`
  mutation markInvoiceAsApprovedOrRejected($invoiceId: Int!, $isApproved: Boolean!) {
    markInvoiceAsApprovedOrRejected(isApproved: $isApproved, invoiceId: $invoiceId) {
      id
      invoiceNo
      subTotal
      discount
      tax
      totalAmount
      balance
      invoiceStatus
      orderId
      invoiceDate
      IsApproved
    }
  }
`;




export const MARK_INVOICE_AS_SENT = gql`
  mutation markInvoiceAsSent($invoiceId: Int!) {
    markInvoiceAsSent(invoiceId: $invoiceId) {
      id
      invoiceNo
    }
  }
`;